import React from "react";
import AuthLayout from "../components/AuthLayout";

const RegisterPage: React.FC = () => (
  <AuthLayout>
    <div className="text-center">Register Page</div>
  </AuthLayout>
);

export default RegisterPage;
